import Hero from "../components/Hero";
import HeroImage from "../../assets/images/BusinessProtection1.jpg";
import businessProtectionImage from "../../assets/images/BusinessProtection2.jpg";
import Accordion from "../designSystem/Accordion";

const BusinessProtectionPage = () => {
  return (
    <div className="home-page">
      <Hero
        title="Business Protection"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <section className="grey-container">
        <div className="grey-container-content">
          <div className="row">
            <div className="content-column">
              <h2 className="burgandy align-left">
                What is Business Protection?
              </h2>
              <div className="divider burgandy align-left" />
              <div className="content grey align-left">
                Business protection helps safeguard your company against
                unexpected events such as the death or serious illness of an
                owner, partner, or key employee. It ensures financial stability,
                continuity, and control during difficult times.
              </div>
            </div>
            <img
              src={businessProtectionImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
          </div>
        </div>
      </section>
      <section className="white-container">
        <div className="white-container-content">
          <div className="column">
            <h2 className="burgandy">Types of Business Protection</h2>
            <div className="divider burgandy" />
            <Accordion title="Shareholder Protection">
              Designed for limited companies, this cover provides funds for
              remaining shareholders to buy the shares of a deceased or
              critically ill shareholder. This helps maintain control and
              protects the future of the business.
            </Accordion>
            <Accordion title="Key Person Insurance">
              Protects your business against financial loss if a key employee
              dies or becomes seriously ill. It can help cover lost profits,
              recruitment costs, or business disruption.
            </Accordion>
            <Accordion title="Partnership Protection">
              <ul>
                <li>
                  Ensures business continuity if a partner dies or becomes
                  critically ill. It provides funds for surviving partners to
                  buy the deceased partner’s share from their estate, helping
                  avoid disputes and keeping control within the business.
                </li>
                <li>
                  Without protection, a partner’s share may pass to their
                  beneficiaries, who may not be involved in the business.
                </li>
              </ul>
            </Accordion>
            <Accordion title="How Partnership Protection Works">
              <ul>
                <li>
                  Partners agree what should happen if one of them dies or
                  becomes ill
                </li>
                <li>
                  A legal agreement is put in place (e.g. buy and sell or
                  cross-option agreement)
                </li>
                <li>
                  Insurance policies provide a lump sum to fund the buyout
                </li>
                <li>Surviving partners can continue running the business</li>
                <li>
                  This approach is often more practical than relying on loans,
                  which can be costly and difficult to secure.
                </li>
              </ul>
            </Accordion>
            <Accordion title="Key Benefits">
              <ul>
                <li>Maintains business continuity</li>
                <li>Protects ownership and control</li>
                <li>
                  Provides financial security for families and business partners
                </li>
                <li>Avoids the need for borrowing at difficult times</li>
              </ul>
            </Accordion>
            <Accordion title="Important Information">
              <ul>
                <li>
                  Trusts are not regulated by the Financial Conduct Authority
                </li>
                <li>
                  Policies and cover levels depend on your business structure
                  and needs
                </li>
              </ul>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessProtectionPage;
